import styles from "@/components/modal/affiliate/styles/affiliate-modal.module.scss";
import AffiliateStep from "@/components/modal/affiliate/components/affiliate-step";
import referralIcon from "@/assets/affiliate/referral.svg";
import subscribeIcon from "@/assets/affiliate/subscribe.svg";
import earnIcon from "@/assets/affiliate/earn.svg";
import Link from "next/link";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import CopyTextBar from "@/components/common/copy/copy-text-bar";
import CopyProvider from "@/hooks/providers/copy-provider";

const AffiliateModal = () => {
  const { hideModal } = useGlobalModalContext();

  return (
    <CopyProvider>
      <div className={styles.modal_wrapper}>
        <div className={styles.header_wrapper}>
          <div className={styles.header_text}>
            AudioModify Creator Affiliate Program
          </div>
          <div className={styles.header_secondary_text}>
            Make more money telling people about the product you love!
          </div>
          <div className={styles.header_secondary_text}>
            Learn more about the program here.
          </div>
        </div>
        <div className={styles.steps_container}>
          <AffiliateStep
            index={1}
            icon={referralIcon}
            description={
              "Register through the link below and share your unique referral link with people you tell about AudioModify."
            }
          />
          <AffiliateStep
            index={2}
            icon={subscribeIcon}
            description={"They subscribe to AudioModify with your link."}
          />
          <AffiliateStep
            index={3}
            icon={earnIcon}
            description={
              "Earn a 25% commission on every transaction they make."
            }
          />
        </div>
        <div className={styles.contact_us_wrapper}>
          <div className={styles.contact_us_text_wrapper}>
            <div className={styles.secondary_text}>
              Have a large social following?
            </div>
            <div className={styles.details_text}>
              Contact us for exclusive rates and co-marketing opportunities.
            </div>
          </div>
          <Link
            className={styles.contact_us_button}
            href={"/help/contact"}
            onClick={hideModal}
          >
            Contact Us
          </Link>
        </div>
        <div className={styles.paypro_link_wrapper}>
          <CopyTextBar
            text={"https://cc.payproglobal.com/AffiliateSignup/8DD5032865630F7"}
          />
        </div>
      </div>
    </CopyProvider>
  );
};

export default AffiliateModal;
